import React, { useState } from "react";
import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { CreditBalanceOverview } from "@/components/organisms/CreditBalanceOverview";
import { CreditPlans } from "@/components/organisms/CreditPlans";
import { TransactionHistory } from "@/components/organisms/TransactionHistory";
import { useCredits, useCreditActions, useCreditStore } from "@/stores/credits";
import { CreditCard } from "@/components/icons";
import toast from "react-hot-toast";
import { showErrorToast } from "@/utils/errorToast";

export const BillingPage: React.FC = () => {
  const credits = useCredits();
  const creditActions = useCreditActions();
  const creditStore = useCreditStore();
  const [purchasingPlan, setPurchasingPlan] = useState<string | null>(null);

  const handlePurchase = async (planId: string) => {
    setPurchasingPlan(planId);
    try {
      await creditActions.purchaseCredits(planId);
      toast.success("Credits purchased successfully!");
    } catch (error) {
      showErrorToast(error, "Failed to purchase credits");
    } finally {
      setPurchasingPlan(null);
    }
  };


  return (
    <DashboardLayout>
      <div className="p-6 min-h-screen bg-background text-foreground">
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-3 bg-gradient-to-br from-primary/20 to-primary/10 rounded-xl">
                  <CreditCard className="h-8 w-8 text-primary" />
                </div>
                <div>
                  <h1 className="text-4xl font-bold text-foreground">
                    Billing & Credits
                  </h1>
                  <p className="text-muted-foreground text-lg mt-1">
                    Manage your credit balance and billing information
                  </p>
                </div>
              </div>
            </div>

            {/* Current Balance */}
            <div className="mb-8">
              <CreditBalanceOverview 
                balance={credits.balance} 
                usagePercentage={credits.usagePercentage} 
              />
            </div>

            {/* Credit Plans */}
            <div className="mb-8">
              <CreditPlans 
                plans={creditStore.availablePlans}
                purchasingPlan={purchasingPlan}
                onPurchase={handlePurchase}
              />
            </div>

            {/* Transaction History */}
            <TransactionHistory transactions={creditStore.transactions} />
      </div>
    </DashboardLayout>
  );
};